<script>
  import { alert } from 'vue-strap';
  
  export default {
    components: { alert },
    props: {
      itensSolicitacao: {
        type: Array,
        required: true
      },
      relatorio: {
        type: Boolean,
        required: false,
        default: false
      },
    },
    methods: {
      deletarItem(indice) {
        this.itensSolicitacao.splice(indice, 1);
      },
      calcularTotal(item) {
        const valor = item.valorItem;
        const quantidade = item.quantidadeItem;
        const adicionalDesconto = item.adicionalItem;
        
        return quantidade * valor + adicionalDesconto;
      }
    },
    computed: {
      total() {
        return this.itensSolicitacao.reduce((somatorio, item) => {
          return somatorio + this.calcularTotal(item);
        }, 0);
      },
    }
  }
</script>

<template>
  <div>
    
    <alert type="warning" v-if="itensSolicitacao.length === 0">
      <i class="fa fa-warning"></i> Nenhum servicço adicionado.
    </alert>

    <div class="bs-callout bs-callout-info no-margin-top" v-for="(item, indice) in itensSolicitacao">
      <h4>
        Item #{{ indice + 1 }}

        <button
          type="button"
          class="btn btn-sm btn-danger btn-delete-item"
          title="Excluir item"
          @click="deletarItem(indice)"
          v-if="!relatorio">
          <i class="fa fa-trash"></i>
        </button>
      </h4>

      <div class="row">
        <dl class="col-xs-12">
          <dt>Serviço</dt>
          <dd>{{ item.servicoProjeto.descricaoItem }}</dd>
        </dl>
      </div>

      <div class="row">
        <dl class="col-xs-3">
          <dt>Quantidade</dt>
          <dd>{{ item.quantidadeItem }}</dd>
        </dl>
        <dl class="col-xs-3">
          <dt>Valor unitário</dt>
          <dd>{{ item.valorItem | formatarNumero }}</dd>
        </dl>
        <dl class="col-xs-3">
          <dt>{{ item.adicionalItem >= 0 ? 'Acréscimo' : 'Desconto' }}</dt>
          <dd>{{ (item.adicionalItem >= 0 ? item.adicionalItem : -1*item.adicionalItem) | formatarNumero }}</dd>
        </dl>
        <dl class="col-xs-3">
          <dt>Valor total</dt>
          <dd>{{ calcularTotal(item) | formatarNumero }}</dd>
        </dl>
      </div>

      <div class="row">
        <dl class="col-xs-12">
          <dt>Complemento</dt>
          <dd class="white-space-pre">{{ item.observacaoItem }}</dd>
        </dl>
      </div>
    </div>

    <div class="bs-callout bs-callout-primary">
      <h4>Valor total: R$ {{ total | formatarNumero }}</h4>
    </div>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-faturamento-multiservicos/componentes/compartilhado/FormListaServicos.vue